<template>
  <nav id="nav" class="nav">
    <router-link to="/" class="link">Home </router-link>
    <router-link to="/provision-form" class="link">Provision Form </router-link>
    <router-link to="/account" class="link">Account </router-link>
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
.link {
  color: white;
  font-weight: 600;
  background-color: transparent;
}
</style>
